<script lang="ts">
	import { Auth } from "@utils/Auth.svelte.js";
	import { getConfiguratorState } from "@utils/configuratorContext.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { ClassValue } from "svelte/elements";
	import { AuthenticationModalKind } from "@core/schema/AuthenticationModalKind.js";
	import translations from "./BuildYourSubscriptionButton.translations.json" with { type: "json" };
	import Button from "./common/Button.svelte";
	import { ButtonSize } from "./common/ButtonSize.js";
	import type { ButtonVariant } from "./common/ButtonVariant.js";
	import Formatted from "./common/Formatted.svelte";

	const translate = getTranslate(translations);

	const configuratorState = getConfiguratorState();
	const { variant, class: customClass }: { variant: ButtonVariant; class?: ClassValue } = $props();
</script>

<Button
	onclick={async (): Promise<void> => {
		if (Auth.signedIn) {
			configuratorState.open = true;
		} else {
			await Auth.openAuthenticationModal(AuthenticationModalKind.Register, {});
		}
	}}
	size={ButtonSize.Medium}
	class={["[zoom:90%] sm:[zoom:unset] pointer-events-auto", customClass]}
	{variant}
>
	<Formatted text={translate("buildYourSubscription")} />
</Button>
